import { useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../api/api";

export default function DocumentPage() {
  const { id } = useParams();

  useEffect(() => {
    const load = async () => {
      const res = await api.get(`/document/${id}`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      window.open(url, "_blank");
    };

    load();
  }, [id]);

  return;
}